import Relay from 'react-relay';
/**
*  New sport mutation
*/
export default class NewSportMutation extends Relay.Mutation {
  /**
  *  Mutation
  */
  getMutation() {
    return Relay.QL`mutation{
      newSport
    }`;
  }
  /**
  *  Variables
  */
  getVariables() {
    return {
      sport: {
        name: this.props.sport.name,
        logo: this.props.sport.logo,
        positions: this.props.sport.positions,
        certificates: this.props.sport.certificates,        
        levels: this.props.sport.levels,
      }
    };
  }
  /**
  *  Fat query
  */
  getFatQuery() {
    return Relay.QL`
      fragment on newSportPayload @relay(pattern: true){
        viewer {
          sports
        }
        edge
      }
    `;
  }

  /**
  *  Config
  */
  getConfigs() {
    return [{
      type: 'RANGE_ADD',
      parentName: 'viewer',
      parentID: this.props.viewer.id,
      connectionName: 'SportConnection',
      edgeName: 'SportEdge',
      rangeBehaviors: ( () => 'append' )
    }];
  }

  static fragments = {
    viewer: () => Relay.QL`
      fragment on Viewer {
        id
      }
    `,
  }
}


// WEBPACK FOOTER //
// ./src/mutations/Sport/NewSportMutation.js